"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COW_DragonWhelp_ScorchAbilityHandler = exports.COW_DragonWhelp_ScorchActorAbilityFactory = exports.COW_DragonWhelp_ScorchAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class COW_DragonWhelp_ScorchAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.COW_DragonWhelp_Scorch;
        this.__typeName = "COW_DragonWhelp_Scorch";
    }
}
exports.COW_DragonWhelp_ScorchAbilityArgs = COW_DragonWhelp_ScorchAbilityArgs;
let COW_DragonWhelp_ScorchActorAbilityFactory = class COW_DragonWhelp_ScorchActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("COW_DragonWhelp_Scorch", "OneEnemies", 3);
    }
};
COW_DragonWhelp_ScorchActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("COW_DragonWhelp_Scorch")
], COW_DragonWhelp_ScorchActorAbilityFactory);
exports.COW_DragonWhelp_ScorchActorAbilityFactory = COW_DragonWhelp_ScorchActorAbilityFactory;
let COW_DragonWhelp_ScorchAbilityHandler = class COW_DragonWhelp_ScorchAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: [
                {
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Focus("Fire", 80)
                    ],
                    effects: [
                        {
                            duration: Duration_1.Duration.Permanent,
                            targetId,
                            effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 25)
                        }
                    ]
                }
            ],
            onDebuffApplied: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "FireTornado"));
            }
        });
    }
};
COW_DragonWhelp_ScorchAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.COW_DragonWhelp_Scorch)
], COW_DragonWhelp_ScorchAbilityHandler);
exports.COW_DragonWhelp_ScorchAbilityHandler = COW_DragonWhelp_ScorchAbilityHandler;
